import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { api } from '../api';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import * as _ from 'lodash';
import { TimelineRequestDTO } from './timeline-request.dto';
import { stringify } from 'querystring';

@Injectable()
export class TimelineService {
  private timelineRequest: TimelineRequestDTO = null;
  private timelineData: any = null;
  private sortOptions: any = null;
  fileUrl: any;
  offerBtnId: any;
  offerStatus: any;
  constructor(public http: HttpClient) {
  }

 public loadTimelineNotificationCount() {
   const request: TimelineRequestDTO = new TimelineRequestDTO();
   request.ForceRefresh = false;
   request.IsCareerData = true;
   request.CountOverDueOnly = false;

   return this.http.post(api.timeline.GET_NOTIFICATION_COUNT, request)
     .catch(this.handleError);
  }

  fetchTimelineData(forceRefresh: boolean) {
    return this.http.post(api.timeline.GET_TIMELINE_DATA, this.getTimelineRequest(forceRefresh))
      .toPromise()
      .then(res => {
        this.timelineData = res;
        return true;
      })
      .catch(this.handleError);
 }

  getTimelineViewData() {
    return this.http.post(api.timeline.GET_TIMELINE_VIEW_DATA, this.getTimelineRequest(false))
      .catch(this.handleError);
  }

  getTimelineItems(category: string) {
    if (this.timelineData == null) {
      this.fetchTimelineData(false).then((res) => {
        if (res === true) {
          return this.processTimelineData(category);
        }
      });
    } else if (this.timelineData != null) {
      return this.processTimelineData(category);
    }
  }

  getCategorySortOptions() {
    if (this.sortOptions === null) {
      this.sortOptions = this.timelineData.sortOptions;
    }
    return this.sortOptions;
  }

  processTimelineData(category: string) {
    const categories: any = this.timelineData.timeline.categories;
    const catKey = 'TIMELINE_CATEGORY_' + category;
    let allBucket;
    let allCategory = {
      buckets: []
    };

    for (let i = 0; i < categories.length; i++) {
      if (categories[i].key === catKey) {
        allCategory = categories[i];
        break;
      }
    }

    for (let i = 0; i < allCategory.buckets.length; i++) {
      if (allCategory.buckets[i].key === 'TIMELINE_BUCKET_ALL') {
        allBucket = allCategory.buckets[i];
        break;
      }
    }
if (allBucket) {
    return allBucket.items;
} else {
    return [];
    }
  }

  applySortFilter(selectedSortOption, timelineData) {
    const sort = selectedSortOption.split(':');
    let nullData = null;
    if (sort[1] === 'dueDate') {
      nullData = timelineData.filter(option => option.dueDate === null);
      timelineData =  timelineData.filter(option => option.dueDate != null);
    } else if (sort[1] === 'startDate') {
      nullData = timelineData.filter(option => option.startDate === null);
      timelineData =  timelineData.filter(option => option.startDate != null);
    }

    timelineData = _.orderBy(timelineData , sort[1] , sort[2]);
    if (nullData != null) {
      nullData.forEach(element => {
        timelineData.push(element);
      });
    }

    return timelineData;
  }

  UpdateOfferStatus(offerId: any, status: any, reasonForRejection: string) {
    const httpParams: HttpParams = new HttpParams()
    .set('offerId', offerId.toString())
    .set('status', status.toString())
    .set('reasonForRejection',  reasonForRejection);
    httpParams.keys().forEach((key) => {
      const value = httpParams.get(key);
      if (value === null || value === undefined || value === '') {
        httpParams['map'].delete(key);
      }
    });
    return this.http.post(api.offer.UPDATE_OFFER_STATUS, null, { params: httpParams } )
      .toPromise()
      .then(res => {
        return res;
      })
      .catch(this.handleError);
 }

  private getTimelineRequest(forceRefresh: boolean): TimelineRequestDTO {
    const request: TimelineRequestDTO = new TimelineRequestDTO();
    request.ForceRefresh = forceRefresh;
    request.IsCareerData = true;
    return request;
  }

  private handleError(error: any) {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// ../UI/src/app/shared/timeline/timeline.service.ts